export default "__VITE_ASSET__8ba9f2a2__"